export default "__VITE_ASSET__Bbia8DNC__"